/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An asterisk marks a stop codon (TAA, TAG or TGA), which terminates translation. Enable “stop at first stop codon” to end the protein there.`)
};

const es_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asterisco marca un codón de parada (TAA, TAG o TGA), que termina la traducción. Activa «detener en el primer codón de parada» para terminar la proteína ahí.`)
};

const de_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Sternchen markiert ein Stoppcodon (TAA, TAG oder TGA), das die Übersetzung beendet. Aktivieren Sie „Am ersten Stoppcodon anhalten“, um das Protein dort zu beenden.`)
};

const nl_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een sterretje markeert een stopcodon (TAA, TAG of TGA), dat de vertaling beëindigt. Schakel "stop bij eerste stopcodon" in om het eiwit daar te laten eindigen.`)
};

const fr_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un astérisque marque un codon stop (TAA, TAG ou TGA), qui met fin à la traduction. Activez « arrêter au premier codon stop » pour terminer la protéine à cet endroit.`)
};

const it_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asterisco indica un codone di stop (TAA, TAG o TGA), che termina la traduzione. Attiva “fermati al primo codone di stop” per terminare la proteina lì.`)
};

const pt_br2_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um asterisco marca um códon de parada (TAA, TAG ou TGA), que encerra a tradução. Ative “parar no primeiro códon de parada” para terminar a proteína ali.`)
};

const pt_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um asterisco assinala um codão de paragem (TAA, TAG ou TGA), que termina a tradução. Ative “parar no primeiro codão de paragem” para terminar a proteína aí.`)
};

const ja_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスタリスクは終止コドン (TAA、TAG、TGA) を示し、翻訳を終了させます。「最初の終止コドンで停止」を有効にすると、そこでタンパク質を終了させます。`)
};

const zh_translate_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星号标记终止密码子（TAA、TAG 或 TGA），表示翻译终止。启用“在第一个终止密码子处停止”可让蛋白质在此处结束。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_a3", locale)
	if (locale === "en") return en_translate_faq_a3(inputs)
	if (locale === "es") return es_translate_faq_a3(inputs)
	if (locale === "de") return de_translate_faq_a3(inputs)
	if (locale === "nl") return nl_translate_faq_a3(inputs)
	if (locale === "fr") return fr_translate_faq_a3(inputs)
	if (locale === "it") return it_translate_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_a3(inputs)
	if (locale === "pt") return pt_translate_faq_a3(inputs)
	if (locale === "ja") return ja_translate_faq_a3(inputs)
	return zh_translate_faq_a3(inputs)
};